import { render, staticRenderFns } from "./CreateTeamGramChannel.vue?vue&type=template&id=2fa754c2&scoped=true"
import script from "./CreateTeamGramChannel.vue?vue&type=script&lang=js"
export * from "./CreateTeamGramChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateTeamGramChannel.vue?vue&type=style&index=0&id=2fa754c2&prod&lang=scss&scoped=true"
import style1 from "./CreateTeamGramChannel.vue?vue&type=style&index=1&id=2fa754c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa754c2",
  null
  
)

export default component.exports